<!-- <mat-drawer-container class="example-container side-men" [ngClass]="{'menuslider' : menu_slider}">
    <mat-drawer class="side" mode="side" opened (mouseover)="menuslide()" (mouseout)="menuslide()">
        <mat-nav-list>
            <mat-list-item routerLink="dashboard" (click)="act()">
                <mat-icon style="color: #fff;"> notes</mat-icon>
            </mat-list-item>
            <mat-list-item routerLink="dashboard" routerLinkActive="active" (click)="act()">
                <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-tachometer" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Dashboard</h5>
                </div>
            </mat-list-item>





            <mat-list-item routerLinkActive="active" [matMenuTriggerFor]="menu2" pTooltip="Master" (click)="act3()"
                [ngClass]="{'active' : !expand3}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-database" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Master</h5>
                </div>

            </mat-list-item>
            <mat-menu #menu2="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;">
                    <div class="sub-menu">
                        <mat-list-item *ngIf="login_type == 'Organization'" routerLink="client/Create_client_type"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Client Type</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item *ngIf="login_type == 'Organization'" routerLink="client/Create_portfolio"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Portfolio</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item *ngIf="login_type == 'Organization'" routerLink="client/Create_product"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Product</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item *ngIf="login_type == 'Super_Admin'" routerLink="client/Create_document_type"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Document Type</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item *ngIf="login_type == 'Organization'" routerLink="client/product"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Product Mapping</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item *ngIf="login_type == 'Organization'" routerLink="client/Bucket"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Bucket \Management</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item *ngIf="login_type == 'Organization'" routerLink="field_mapping"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Table/Field Creation</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item *ngIf="login_type == 'Super_Admin'" routerLink="Create_Account_Type"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Account Type</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item *ngIf="login_type == 'Super_Admin'" routerLink="Create_Designation"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Designation</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item *ngIf="login_type == 'Super_Admin'" routerLink="Country"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Country & Currency Management</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item *ngIf="login_type == 'Super_Admin'" routerLink="Create_State"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">State</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item *ngIf="login_type == 'Organization'" routerLink="fieldset" routerLinkActive="active">
                            <div class="sidenav-item">
                                 <h5 class="lead">Create Predefined Fields</h5>
                             </div>
                         </mat-list-item>
                    </div>
                </mat-nav-list>
            </mat-menu>

            <mat-list-item *ngIf="login_type == 'Super_Admin'" routerLink="Super_admin/EntityManagement"
                routerLinkActive="active" (click)="act()" pTooltip="Organization Management">
                <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-sitemap" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Organization Management</h5>
                </div>
            </mat-list-item>






            <mat-list-item *ngIf="login_type == 'Organization'" routerLinkActive="active" [matMenuTriggerFor]="menu"
                pTooltip="Clients" (click)="act1()" [ngClass]="{'active' : !expand1}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-university" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Clients</h5>
                </div>

            </mat-list-item>
            <mat-menu #menu="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;">
                    <div class="sub-menu">

                        <mat-list-item routerLink="Clients" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Clients Management</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="client/client_status_marking" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Client Status Marking</h5>
                            </div>
                        </mat-list-item>
                    </div>
                </mat-nav-list>
            </mat-menu>




            <mat-list-item *ngIf="login_type == 'Organization'" routerLinkActive="active" [matMenuTriggerFor]="menu1" pTooltip="User Master" (click)="act2()" [ngClass]="{'active' : !expand2}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-user" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">User Master</h5>
                </div>
            </mat-list-item>
            <mat-menu #menu1="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;">
                    <div class="sub-menu">
                        <mat-list-item routerLink="user/user_type" routerLinkActive="active">
                            <div class="sidenav-item">
                                 <h5 class="lead">User Type</h5>
                             </div>
                         </mat-list-item>
                        <mat-list-item routerLink="user/user_role" routerLinkActive="active">
                           <div class="sidenav-item">
                                <h5 class="lead">User Role</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item routerLink="user/user_group" routerLinkActive="active">
                          <div class="sidenav-item">
                                <h5 class="lead">User Group</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item routerLink="user/user_management" routerLinkActive="active">
                           <div class="sidenav-item">
                                <h5 class="lead">User Management</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="user/user_status_marking" routerLinkActive="active">
                        <div class="sidenav-item">
                                <h5 class="lead">User Status Marking</h5>
                            </div>
                        </mat-list-item>
                    </div>
                </mat-nav-list>
            </mat-menu>







            <mat-list-item *ngIf="login_type == 'Organization'" routerLinkActive="active" [matMenuTriggerFor]="menu3"
                pTooltip="Allocations" (click)="act4()" [ngClass]="{'active' : !expand4}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-tasks" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Allocations</h5>
                </div>

            </mat-list-item>
            <mat-menu #menu3="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;">
                    <div class="sub-menu">
                        <mat-list-item routerLink="userflow/allocationexcel" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Excel Upload</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item routerLink="userflow/allocationsingle" routerLinkActive="active">
                            <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-globe"
                                    aria-hidden="true"
                                    style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                            <div fxFlex="10"></div>
                            <div class="sidenav-item">
                                <h5 class="lead">Allocate Single (1 to 1)</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="userflow/withdrawsingle" routerLinkActive="active">
                            <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-globe"
                                    aria-hidden="true"
                                    style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                            <div fxFlex="10"></div>
                            <div class="sidenav-item">
                                <h5 class="lead">Withdraw Single (1 to 1)</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item routerLink="userflow/withdrawexcel" routerLinkActive="active">
                            <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-globe"
                                    aria-hidden="true"
                                    style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                            <div fxFlex="10"></div>
                            <div class="sidenav-item">
                                <h5 class="lead">Withdraw Excel (upload)</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item routerLink="userflow/reallowsingle" routerLinkActive="active">
                            <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-globe"
                                    aria-hidden="true"
                                    style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                            <div fxFlex="10"></div>
                            <div class="sidenav-item">
                                <h5 class="lead">Re-allocate Single (1 to 1)</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item routerLink="userflow/reallowexcel" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Re-allocate</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item routerLink="userflow/Dual_Temporary_allocation" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Dual/Temporary allocation</h5>
                            </div>
                        </mat-list-item>
                    </div>
                </mat-nav-list>
            </mat-menu>





            <mat-list-item *ngIf="login_type == 'Organization'" routerLinkActive="active" [matMenuTriggerFor]="menu5"
                pTooltip="Accounts" (click)="act6()" [ngClass]="{'active' : !expand6}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-list-alt" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Inbox</h5>
                </div>
            </mat-list-item>
            <mat-menu #menu5="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;" *ngIf="expand2">
                    <div class="sub-menu">
                        <mat-list-item routerLink="Agent_Inbox" routerLinkActive="active" pTooltip="Agent Inbox"
                            (click)="act()">

                            <div class="sidenav-item">
                                <h5 class="lead">Portfolio inbox</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Notification inbox</h5>
                            </div>
                        </mat-list-item>
                    </div>
                </mat-nav-list>
            </mat-menu>



            <mat-list-item *ngIf="login_type == 'Organization'" routerLinkActive="active" [matMenuTriggerFor]="menu6"
                pTooltip="User Details" (click)="act7()" [ngClass]="{'active' : !expand7}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-users" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Users</h5>
                </div>

            </mat-list-item>
            <mat-menu #menu6="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;" *ngIf="expand3">
                    <div class="sub-menu">
                        <mat-list-item routerLink="user/createuser" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Customer 360</h5>
                            </div>
                        </mat-list-item>
                    </div>
                    <div class="sub-menu">
                        <mat-list-item routerLink="Configuration" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Configuration Screen</h5>
                            </div>
                        </mat-list-item>
                    </div>
                </mat-nav-list>
            </mat-menu>






  <mat-list-item   (click)="logout()" *ngIf="login_type == 'Super_Admin' || login_type == 'Organization'"
  pTooltip="Logout" (click)="act7()">
  <mat-icon style="color: #fff !important;" mat-list-icon>
      <i class="fa fa-sign-out" aria-hidden="true"
          style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
  <div fxFlex="10"></div>
  <div class="sidenav-item">
      <h5 class="lead">Logout</h5>
  </div>


</mat-list-item>




        </mat-nav-list>
    </mat-drawer>
    <mat-drawer-content style="margin-left: 30px !important;">
        <section style="padding:15px;background:#f2efefd1;">
            <router-outlet></router-outlet>
        </section>

    </mat-drawer-content>
</mat-drawer-container> -->



<!-- /////////////////////////////////////////////////////// -->



<mat-drawer-container class="example-container side-men" [ngClass]="{'menuslider' : menu_slider}">
    <mat-drawer class="side" mode="side" opened (mouseover)="menuslide()" (mouseout)="menuslide()">
        <mat-nav-list>
            <mat-list-item routerLink="dashboard" (click)="act()">
                <mat-icon style="color: #fff;"> notes</mat-icon>
            </mat-list-item>
            <mat-list-item routerLink="dashboard" routerLinkActive="active" (click)="act()" *ngIf="Dashboard_show">
                <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-tachometer" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Dashboard</h5>
                </div>
            </mat-list-item>

            <mat-list-item routerLinkActive="active" *ngIf="Works_show" [matMenuTriggerFor]="menu8" pTooltip="WORKS"
                (click)="act8()" [ngClass]="{'active' : !expand8}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-database" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">WORKS</h5>
                </div>

            </mat-list-item>
            <mat-menu #menu8="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;">
                    <div class="sub-menu">
                        <mat-list-item routerLink="porfilo_buckets" routerLinkActive="active" *ngIf="Worklist_show">
                            <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-tachometer"
                                    aria-hidden="true"
                                    style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                            <div fxFlex="10"></div>
                            <div class="sidenav-item">
                                <h5 class="lead">WorkList</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="accounts/FollowupCalander" routerLinkActive="active">
                            <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-tachometer"
                                    aria-hidden="true"
                                    style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                            <div fxFlex="10"></div>
                            <div class="sidenav-item">
                                <h5 class="lead">Followup Calander</h5>
                            </div>
                        </mat-list-item>


                        <mat-list-item routerLink="bucket_details" routerLinkActive="active" *ngIf="Allocation_show">
                            <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-tachometer"
                                    aria-hidden="true"
                                    style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                            <div fxFlex="10"></div>
                            <div class="sidenav-item">
                                <h5 class="lead">Allocations</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item *ngIf="Re_Allocation_show" routerLink="accounts/reallocation"
                            routerLinkActive="active">
                            <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-tachometer"
                                    aria-hidden="true"
                                    style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                            <div fxFlex="10"></div>
                            <div class="sidenav-item">
                                <h5 class="lead">Re-allocation</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="userflow/reportingtolist" routerLinkActive="active"
                            *ngIf="Team_Allocation_show">
                            <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-tachometer"
                                    aria-hidden="true"
                                    style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                            <div fxFlex="10"></div>
                            <div class="sidenav-item">
                                <h5 class="lead">Team Allocations</h5>
                            </div>
                        </mat-list-item>



                        <mat-list-item *ngIf="To_Do_List_show">
                            <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-list"
                                    aria-hidden="true"
                                    style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                            <div fxFlex="10"></div>
                            <div class="sidenav-item">
                                <h5 class="lead">To do List</h5>
                            </div>
                        </mat-list-item>

                    </div>
                </mat-nav-list>
            </mat-menu>


            <mat-list-item routerLinkActive="active" *ngIf="Master_Data_show" [matMenuTriggerFor]="menu12"
                pTooltip="Master" (click)="act3()" [ngClass]="{'active' : !expand3}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-database" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Master Data</h5>
                </div>
            </mat-list-item>

            <mat-menu #menu12="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;">
                    <div class="sub-menu">
                        <mat-list-item routerLink="account_details" routerLinkActive="active">
                            <div class="sidenav-item">
                                <h5 class="lead">Account List</h5>
                            </div>
                        </mat-list-item>
                    </div>
                </mat-nav-list>
            </mat-menu>







            <mat-list-item routerLinkActive="active" *ngIf="Master_show" [matMenuTriggerFor]="menu2" pTooltip="Master"
                (click)="act3()" [ngClass]="{'active' : !expand3}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-database" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Master</h5>
                </div>

            </mat-list-item>
            <mat-menu #menu2="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;">
                    <div class="sub-menu">
                        <mat-list-item routerLink="bank_details" routerLinkActive="active">
                            <div class="sidenav-item">
                                <h5 class="lead">Company / Client</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="Create_Designation" routerLinkActive="active">
                            <div class="sidenav-item">
                                <h5 class="lead">Designations</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="user_details" routerLinkActive="active">
                            <div class="sidenav-item">
                                <h5 class="lead">User Managements</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="client/Create_client_type" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Client Type</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="create/status" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Status / Sub Status</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="user/create-team" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Teams & Members</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="user/new_create_team" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">New Teams & Members</h5>
                            </div>
                        </mat-list-item>


                        <mat-list-item routerLink="create/actiontaken" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Actions Taken</h5>
                            </div>
                        </mat-list-item>


                        <mat-list-item routerLink="create/tracingtools" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Tracing Tools</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="create/approval_status" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Approval Status</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="create/logtype" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Log Type</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="create/bankcode" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Bank Code</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="create/fvcode" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Field Visit Territary</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="create/areacode" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Field Visit Area</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="client/Create_portfolio" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Portfolio</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item routerLink="client/Create_product" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Product</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item routerLink="client/Create_document_type" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Document Type</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item routerLink="client/product" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Product Mapping</h5>
                            </div>
                        </mat-list-item>
                        <!-- <mat-list-item *ngIf="bucket_mang_show"  routerLink="client/Bucket"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Bucket \Management</h5>
                            </div>
                        </mat-list-item> -->

                        <mat-list-item routerLink="field_mapping" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Table/Field Creation</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item routerLink="Create_Account_Type" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Account Type</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item routerLink="create/sms-templates" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">SMS Templates</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="create/sms-scheduler" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">SMS Scheduler</h5>
                            </div>
                        </mat-list-item>
                        <!-- <mat-list-item *ngIf="desingation_show" routerLink="Create_Designation"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Designation</h5>
                            </div>
                        </mat-list-item> -->
                        <!-- <mat-list-item *ngIf="country_currency_show"  routerLink="Country"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Country & Currency Management</h5>
                            </div>
                        </mat-list-item> -->
                        <!-- <mat-list-item *ngIf="state_show" routerLink="Create_State"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">State</h5>
                            </div>
                        </mat-list-item> -->
                        <mat-list-item routerLink="fieldset" routerLinkActive="active">
                            <div class="sidenav-item">
                                <h5 class="lead">Create Predefined Fields</h5>
                            </div>
                        </mat-list-item>

                        <!-- <mat-list-item routerLink="report-management/admin-report" routerLinkActive="active">
                            <div class="sidenav-item">
                                 <h5 class="lead">Reports</h5>
                             </div>
                         </mat-list-item> -->
                    </div>
                </mat-nav-list>
            </mat-menu>

            <!-- <mat-list-item *ngIf="organization_mag_show"   routerLink="Super_admin/EntityManagement"
                routerLinkActive="active" (click)="act()" pTooltip="Organization Management">
                <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-sitemap" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Organization Management</h5>
                </div>
            </mat-list-item> -->






            <!-- <mat-list-item *ngIf="Mennu3_show"  routerLinkActive="active" [matMenuTriggerFor]="menu"
                pTooltip="Clients" (click)="act1()" [ngClass]="{'active' : !expand1}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-university" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Clients</h5>
                </div>

            </mat-list-item> -->
            <!-- <mat-menu #menu="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;">
                    <div class="sub-menu">

                        <mat-list-item *ngIf="clientmanagement_show" routerLink="Clients" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Clients Management</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item *ngIf="clienstatusmaking_show" routerLink="client/client_status_marking" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Client Status Marking</h5>
                            </div>
                        </mat-list-item>
                    </div>
                </mat-nav-list>
            </mat-menu> -->








            <!-- <mat-list-item *ngIf="Mennu4_show"   routerLinkActive="active" [matMenuTriggerFor]="menu1" pTooltip="User Master" (click)="act2()" [ngClass]="{'active' : !expand2}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-user" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">User Master</h5>
                </div>
            </mat-list-item> -->
            <!-- <mat-menu #menu1="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;">
                    <div class="sub-menu">
                        <mat-list-item *ngIf="usertypecreate_show" routerLink="user/user_type" routerLinkActive="active">
                            <div class="sidenav-item">
                                 <h5 class="lead">User Type</h5>
                             </div>
                         </mat-list-item>
                        <mat-list-item *ngIf="userrol_show" routerLink="user/user_role" routerLinkActive="active">
                           <div class="sidenav-item">
                                <h5 class="lead">User Role</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item *ngIf="usergroup_show" routerLink="user/user_group" routerLinkActive="active">
                          <div class="sidenav-item">
                                <h5 class="lead">User Group</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item *ngIf="usermanagemnt_show" routerLink="user/user_management" routerLinkActive="active">
                           <div class="sidenav-item">
                                <h5 class="lead">User Management</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item *ngIf="userstautsamking_show" routerLink="user/user_status_marking" routerLinkActive="active">
                        <div class="sidenav-item">
                                <h5 class="lead">User Status Marking</h5>
                            </div>
                        </mat-list-item>
                    </div>
                </mat-nav-list>
            </mat-menu> -->






            <!-- *ngIf="Mennu5_show"  -->
            <mat-list-item routerLinkActive="active" [matMenuTriggerFor]="menu3" pTooltip="Allocations" (click)="act4()"
                [ngClass]="{'active' : !expand4}" *ngIf="Excel_Upload_show">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-tasks" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Allocations</h5>
                </div>

            </mat-list-item>
            <mat-menu #menu3="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;">
                    <div class="sub-menu">
                        <mat-list-item routerLink="userflow/allocationexcel" routerLinkActive="active"
                            *ngIf="Excel_Upload_show">

                            <div class="sidenav-item">
                                <h5 class="lead">Excel Upload</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="userflow/excelfintcheck" routerLinkActive="active"
                            *ngIf="Excel_Upload_show">
                            <div class="sidenav-item">
                                <h5 class="lead">Fint Id Generation</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLink="userflow/excelfintcheck2" routerLinkActive="active"
                            *ngIf="Excel_Upload_show">
                            <div class="sidenav-item">
                                <h5 class="lead">Upload Direct</h5>
                            </div>
                        </mat-list-item>
                        <!-- <mat-list-item routerLink="userflow/allocationsingle" routerLinkActive="active">
                            <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-globe"
                                    aria-hidden="true"
                                    style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                            <div fxFlex="10"></div>
                            <div class="sidenav-item">
                                <h5 class="lead">Allocate Single (1 to 1)</h5>
                            </div>
                        </mat-list-item> -->

                        <!-- <mat-list-item routerLink="userflow/withdrawsingle" routerLinkActive="active">
                            <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-globe"
                                    aria-hidden="true"
                                    style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                            <div fxFlex="10"></div>
                            <div class="sidenav-item">
                                <h5 class="lead">Withdraw Single (1 to 1)</h5>
                            </div>
                        </mat-list-item> -->
                        <!-- <mat-list-item routerLink="userflow/withdrawexcel" routerLinkActive="active">
                            <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-globe"
                                    aria-hidden="true"
                                    style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                            <div fxFlex="10"></div>
                            <div class="sidenav-item">
                                <h5 class="lead">Withdraw Excel (upload)</h5>
                            </div>
                        </mat-list-item> -->
                        <!-- <mat-list-item routerLink="userflow/reallowsingle" routerLinkActive="active">
                            <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-globe"
                                    aria-hidden="true"
                                    style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                            <div fxFlex="10"></div>
                            <div class="sidenav-item">
                                <h5 class="lead">Re-allocate Single (1 to 1)</h5>
                            </div>
                        </mat-list-item> -->
                        <!-- <mat-list-item routerLink="userflow/reallowexcel" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Re-allocate</h5>
                            </div>
                        </mat-list-item>
                        <mat-list-item routerLink="userflow/Dual_Temporary_allocation" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Dual/Temporary allocation</h5>
                            </div>
                        </mat-list-item> -->


                        <!-- <mat-list-item routerLink="userflow/newallocation" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">New Allocation</h5>
                            </div>
                        </mat-list-item> -->

                    </div>
                </mat-nav-list>
            </mat-menu>





            <mat-list-item routerLink="followup/bulk_excel_upload" routerLinkActive="active"
                (click)="act()" pTooltip="FollowUp Bulk Upload">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-upload" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">FollowUp Bulk Upload</h5>
                </div>
            </mat-list-item>

            <mat-list-item *ngIf="Approvals_show" routerLinkActive="active" [matMenuTriggerFor]="menu5"
                pTooltip="Accounts" (click)="act6()" [ngClass]="{'active' : !expand6}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-list-alt" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Approvals</h5>
                </div>
            </mat-list-item>
            <mat-menu #menu5="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;" *ngIf="Approvals_show">
                    <div class="sub-menu">
                        <!-- <mat-list-item *ngIf="portfolioinbox_show" routerLink="Agent_Inbox" routerLinkActive="active" pTooltip="Agent Inbox"
                            (click)="act()">

                            <div class="sidenav-item">
                                <h5 class="lead">Portfolio inbox</h5>
                            </div>
                        </mat-list-item> -->
                        <mat-list-item *ngIf="notificationinbox_show" routerLinkActive="active"
                            routerLink="/notifications">

                            <div class="sidenav-item">
                                <h5 class="lead">Notification inbox</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item *ngIf="notificationinbox_show" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Account Transfer Request</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item *ngIf="notificationinbox_show" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Account Assistance Request</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item *ngIf="field_visit_approval_request" routerLink="allocation/approval-request"
                            routerLinkActive="active">
                            <div class="sidenav-item">
                                <h5 class="lead">Field Visit Approval Request</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item *ngIf="field_visit_agent_approval_request" routerLink="allocation/agent-request"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Field Visit Agent Request</h5>
                            </div>
                            `
                        </mat-list-item>

                        <mat-list-item *ngIf="settlement_approval_request" routerLink="allocation/set-approval-request"
                            routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Settlement Approval Request</h5>
                            </div>
                        </mat-list-item>


                        <!-- <mat-list-item *ngIf="allocation_show" routerLink="accounts/allocation" routerLinkActive="active">

                        <div class="sidenav-item">
                            <h5 class="lead">Allocation</h5>
                        </div>
                    </mat-list-item>

                     -->

                        <!-- <mat-list-item *ngIf="reallocation_show" routerLink="accounts/reallocation" routerLinkActive="active">
                        <div class="sidenav-item">
                            <h5 class="lead">Re-allocation</h5>
                        </div>
                    </mat-list-item>

                    <mat-list-item *ngIf="work_list_show" routerLink="accounts/worklist" routerLinkActive="active">
                      <div class="sidenav-item">
                          <h5 class="lead">Work list</h5>
                      </div>
                    </mat-list-item> -->

                    </div>
                </mat-nav-list>
            </mat-menu>

            <mat-list-item routerLinkActive="active" *ngIf="Master_reports_show" [matMenuTriggerFor]="menu16"
                pTooltip="Master" (click)="act3()" [ngClass]="{'active' : !expand3}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-database" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Master Reports</h5>
                </div>

            </mat-list-item>

            <mat-menu #menu16="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;">
                    <div class="sub-menu">
                        <mat-list-item routerLink="report-management/admin-report" routerLinkActive="active">
                            <div class="sidenav-item">
                                <h5 class="lead">View Reports</h5>
                            </div>
                        </mat-list-item>
                    </div>
                </mat-nav-list>
            </mat-menu>



            <!-- <mat-list-item *ngIf="Mennu7_show"  routerLinkActive="active" [matMenuTriggerFor]="menu6"
                pTooltip="User Details" (click)="act7()" [ngClass]="{'active' : !expand7}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-users" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Users</h5>
                </div>

            </mat-list-item> -->
            <!-- <mat-menu #menu6="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;" *ngIf="expand3">
                    <div class="sub-menu">
                        <mat-list-item *ngIf="customer_show" routerLink="user/createuser" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Customer 360</h5>
                            </div>
                        </mat-list-item>
                    </div>
                    <div class="sub-menu">
                        <mat-list-item *ngIf="configurationsscreen_show" routerLink="Configuration" routerLinkActive="active">

                            <div class="sidenav-item">
                                <h5 class="lead">Configuration Screen</h5>
                            </div>
                        </mat-list-item>
                    </div>
                </mat-nav-list>
            </mat-menu> -->



            <!-- <mat-list-item *ngIf="this.login_Details.designation == 'Super Admin'"   routerLinkActive="active" [matMenuTriggerFor]="menu8"
                pTooltip="Super Admin" (click)="act8()" [ngClass]="{'active' : !expand8}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-university" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Super Admin</h5>
                </div>

            </mat-list-item> -->
            <!-- <mat-menu #menu8="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;">
                    <div class="sub-menu">

                        <mat-list-item  routerLink="admin_create" routerLinkActive="active">
                            <div class="sidenav-item">
                                <h5 class="lead">Admin User Create</h5>
                            </div>
                        </mat-list-item>


                        <mat-list-item routerLink="megreinguser" routerLinkActive="active">
                            <div class="sidenav-item">
                                <h5 class="lead">Merge Candidate</h5>
                            </div>
                        </mat-list-item>

                    </div>
                </mat-nav-list>
            </mat-menu> -->


            <mat-list-item *ngIf="this.login_Details.designation == 'Super Admin'" routerLinkActive="active"
                [matMenuTriggerFor]="menu9" pTooltip="Reports" (click)="act8()" [ngClass]="{'active' : !expand9}">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-university" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Reports</h5>
                </div>

            </mat-list-item>



            <mat-list-item routerLink="global_search_results" *ngIf="Globle_Search" routerLinkActive="active"
                (click)="act()">
                <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-tachometer" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">global search results</h5>
                </div>
            </mat-list-item>

            <mat-list-item routerLink="report/overallfollowupreport" *ngIf="Report_for_Agent" routerLinkActive="active"
                (click)="act()">
                <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-tachometer" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">DCR Report</h5>
                </div>
            </mat-list-item>


            <mat-list-item routerLink="report/teamheadoverallfollowreport" *ngIf="Report_for_Team_Head"
                routerLinkActive="active" (click)="act()">
                <mat-icon style="color: #fff !important;" mat-list-icon><i class="fa fa-tachometer" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">DCR Report</h5>
                </div>
            </mat-list-item>



            <mat-menu #menu9="matMenu">
                <mat-nav-list style="background: rgb(32 53 63);padding-left: 5px;">
                    <div class="sub-menu">

                        <mat-list-item routerLinkActive="active">
                            <div class="sidenav-item">
                                <h5 class="lead">Settlement Tracker</h5>
                            </div>
                        </mat-list-item>


                        <mat-list-item routerLinkActive="active">
                            <div class="sidenav-item">
                                <h5 class="lead">PTP Report</h5>
                            </div>
                        </mat-list-item>

                        <mat-list-item routerLinkActive="active">
                            <div class="sidenav-item">
                                <h5 class="lead">Status Report</h5>
                            </div>
                        </mat-list-item>

                    </div>
                </mat-nav-list>
            </mat-menu>






            <mat-list-item (click)="logout()" pTooltip="Logout" (click)="act7()">
                <mat-icon style="color: #fff !important;" mat-list-icon>
                    <i class="fa fa-sign-out" aria-hidden="true"
                        style="position: absolute;color: #fff !important;font-size: 15px;"></i></mat-icon>
                <div fxFlex="10"></div>
                <div class="sidenav-item">
                    <h5 class="lead">Logout</h5>
                </div>


            </mat-list-item>



        </mat-nav-list>
    </mat-drawer>
    <mat-drawer-content style="margin-left: 30px !important;">

        <router-outlet (activate)="onActivate($event)"></router-outlet>

    </mat-drawer-content>
</mat-drawer-container>